/***
 * Corner Component Descriptions
 */
export const cornerDescription = {
	home: {
		cornerH2: "Updated - 2026",
		description:
			"UI Engineer turning designs into code. Building Interfaces that feel as good as they look. Focused on Pixel-Perfect, Responsive & Immersive web experience.",
	},

	ui: {
		cornerH2: "based - Sydney",
		description:
			"I build digital experiences that blend user-centric designs with creativity, bringing ideas to life accross web, mobile and interactive device — and leave a lasting impression",
	},
	webgl: {
		cornerH2: "DSGND - 2025",
		description:
			"Lot of people don't realize the importance of user engagement with their product. 3D can enable it easily.",
	},
	interaction: {
		cornerH2: "EDU - darwin",
		description:
			"A Memorable and Impactful website requires users to interact with the website. Motion captures users attention. It makes user to memember the website.",
	},
	focus: {
		cornerH2: "Dsgnd - 2025",
		description:
			"As Quality does not always come from doing more, but doing less with intention. I try to centralise my thinking, this helps me to focus on one thing rather wondering around on multiples. Because,  when we build, we are not just building a website, It's a Brand.",
	},
	education: {
		cornerH2: "Darwin - Australia",
		description:
			"I studied Bachelor of Information Technology at Charles Darwin University, Australia. Human-Computer Interaction Design, Biulding Ineractive Software & Business Intelligence and Data Mining were some of my major subjects.",
	},

	myworks: {
		cornerH2: "Dsgnd - 2025",
		description:
			"I've implemented Fully responsive layout matching the figma design with pixel-perfect precision. Built reusable react components with styled components GSAP scroll animation.",
	},
	ecommerce: {
		cornerH2: "based - dhaka",
		description:
			"I have developed fully responsive e-commerce website, design collected from frontend mentors challenge. Which is one of their hardest challenges.",
	},
	artgallery: {
		cornerH2: "based - dhaka",
		description:
			"This was a simple art gallery website but I tried to enrich user experience with WebGL, GSAP animation made it more elegant.",
	},
	portfolio: {
		cornerH2: "based - dhaka",
		description:
			"I collaborated with designers and developed personal portfolio. Created custom card slider without any framework.",
	},
	experiences: {
		cornerH2: "",
		description: "",
	},
	contact: {
		cornerH2: "",
		description: "",
	},
};
